import * as asn1js from 'asn1js';
import { Certificate } from 'pkijs';

export function fetchDataFromFile_Blob(data) { 
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = async (event) => {    
            const context = event.target.result;  
            const skiValue = await decodePEM(context)  
            if(skiValue){
                resolve({skiValue, context})
            }
            else reject('X509v3 Subject Key Identifier Not Found')
        }
        reader.onerror = (error) => {
            console.log('Error reading file:', error)
        }
        reader.readAsText(data)
    })
}

export const fetchDataFromFile_Text = async (data) => { 
    const skiValue = await decodePEM(data)  
    if(skiValue){
        return({skiValue, data})
    }
}

const pemToDer = (pem) => {
    const b64 = pem.replace(/(-----(BEGIN|END) CERTIFICATE-----|\s)/g, '');
    return Uint8Array.from(atob(b64), c => c.charCodeAt(0))
}

const arrayBufferToHex = (arrayBuffer) => {
    const uint8array = new Uint8Array(arrayBuffer);
    return Array.from(uint8array).map(byte => byte.toString(16).padStart(2, '0')).join('')
}

const decodePEM = async (pem) => {
    if (!pem) return null;
    try{
        const pemString = pemToDer(pem)
        const asn1 = asn1js.fromBER(pemString.buffer);
        const cert = new Certificate({schema: asn1.result})
        const subjectKeyIdentifier = cert.extensions.find(ext => ext.extnID === '2.5.29.14');
        const skiValue = subjectKeyIdentifier ? await arrayBufferToHex(subjectKeyIdentifier.parsedValue.valueBlock.valueHex).toString('hex') : null;
        return skiValue ? skiValue.toUpperCase() : null;
    }
    catch(error){
        console.log('Error Decoding PEM', error)
    }
}

